export default __webpack_public_path__ + "static/media/sponsor-egale.fc0b2818.png";